export default __webpack_public_path__ + "static/media/clouds-icon.aecc3e7e.svg";